import { render } from "./PriceSettingsDropdown.vue?vue&type=template&id=4f4cb18c&ts=true"
import script from "./PriceSettingsDropdown.vue?vue&type=script&lang=ts"
export * from "./PriceSettingsDropdown.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Nodejs\\MaysTekpanel\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__